import {defineNuxtPlugin} from '#imports';
import {JoyVueLightPlugin} from '@maltjoy/core-vue';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(JoyVueLightPlugin);
});
